/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaUiARewindForwardIcon20Solid = forwardRef('MediaUiARewindForwardIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M10 11.546v3.9c0 1.245 1.431 1.948 2.417 1.186l6.945-5.366a1.6 1.6 0 0 0 0-2.532l-6.945-5.366C11.431 2.606 10 3.308 10 4.555v3.9L3.417 3.368C2.431 2.606 1 3.308 1 4.555v10.89c0 1.246 1.431 1.95 2.417 1.187L10 11.545Z" })));
});
